import { render, staticRenderFns } from "./AbaAtividadeOportunidade.vue?vue&type=template&id=f66b5532"
import script from "./AbaAtividadeOportunidade.vue?vue&type=script&lang=js"
export * from "./AbaAtividadeOportunidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports